module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-403"
  }, [_c('div', {
    staticClass: "error-403__content"
  }, [_c('h1', [_vm._v("403")]), _vm._v(" "), _c('h2', [_vm._v("Access Denied")]), _vm._v(" "), _c('p', [_vm._v("\n      Sorry, but you don't have permission to access this page.\n      "), _c('br'), _vm._v("\n      You can go  "), _c('router-link', {
    attrs: {
      "to": "/admin/live-run"
    }
  }, [_vm._v("Back")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-374ae9b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/403.vue
// module id = 1654
// module chunks = 2